import React, { SyntheticEvent, Component } from 'react';
import sweetalert from 'sweetalert2';
import { logInToFirebase, resetFirebasePassword } from '../util/helperFunctions';
import { Title } from 'bloomer';
import { Label } from 'bloomer/lib/elements/Form/Label';
import { Input } from 'bloomer/lib/elements/Form/Input';
import { Field } from 'bloomer/lib/elements/Form/Field/Field';
import { Control } from 'bloomer/lib/elements/Form/Control';
import { Button } from 'bloomer/lib/elements/Button';
import Conditional from './Conditional';
import { Help } from 'bloomer/lib/elements/Form/Help';

class LoginToAccount extends Component {
  state = {
    loginEmail: '',
    loginPassword: '',
    emailError: '',
    passwordError: '',
    isLoading: false,
  };

  handleChange = (e: SyntheticEvent) => {
    const target = e.target as HTMLInputElement;

    if (target.type === 'checkbox') {
      this.setState({
        [target.name]: target.checked,
      });
    } else {
      this.setState({
        [target.name]: target.value,
      });
    }
  };

  submitForm = async (e: SyntheticEvent) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const { loginEmail, loginPassword } = this.state;
    await logInToFirebase(loginEmail, loginPassword);
    this.setState(
      {
        isLoading: false,
      },
      () => (window.location.href = '/'),
    );
  };

  forgotPassword = async (e: SyntheticEvent) => {
    e.preventDefault();
    const { loginEmail } = this.state;
    this.setState({
      isLoading: true,
    });

    if (loginEmail) {
      const { dismiss } = await sweetalert({
        title: `Reset Password?`,
        text: `Would you like to send a password reset email to ${loginEmail}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, send it!',
        cancelButtonText: 'Hang on a sec...',
      });

      if (dismiss) {
        this.setState({
          isLoading: false,
        });
        return;
      }

      const err = await resetFirebasePassword(this.state.loginEmail);
      if (err && /password/.test(err)) {
        this.setState({
          passwordError: err,
        });
      } else if (err) {
        this.setState({
          emailError: err,
        });
      }
    } else {
      sweetalert({
        title: `Reset Password`,
        text: `You need to enter an email address first...`,
        type: 'error',
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  render() {
    const { loginEmail, loginPassword, emailError, passwordError, isLoading } = this.state;
    return (
      <>
        <Title isSize={4} tag="h2">
          Login:
        </Title>
        <form onSubmit={this.submitForm}>
          <Field>
            <Label htmlFor="loginEmail">Email</Label>
            <Control>
              <Input
                id="loginEmail"
                name="loginEmail"
                type="email"
                required={true}
                onChange={this.handleChange}
                value={loginEmail}
              />
              <Conditional check={emailError.length > 0}>
                <Help isColor="danger">{emailError}</Help>
              </Conditional>
            </Control>
          </Field>
          <Field>
            <Label htmlFor="loginPassword">Password</Label>
            <Control>
              <Input
                id="loginPassword"
                name="loginPassword"
                type="password"
                required={true}
                onChange={this.handleChange}
                value={loginPassword}
              />
              <Conditional check={passwordError.length > 0}>
                <Help isColor="danger">{passwordError}</Help>
              </Conditional>
            </Control>
          </Field>
          <Field isGrouped="centered">
            <Control>
              <Button isLoading={isLoading} disabled={isLoading} isColor="primary" type="submit">
                Log In
              </Button>
            </Control>
            <Control>
              <Button
                isLoading={isLoading}
                disabled={isLoading}
                isColor="primary"
                id="forgotPasswordBttn"
                onClick={this.forgotPassword}
              >
                Forgot Password
              </Button>
            </Control>
          </Field>
        </form>
      </>
    );
  }
}

export default LoginToAccount;
